<!-- Map styles -->
<div class="form-group" style="flex-grow: 0">
  <label for="travelMode">{{'Map style:' | translate}}</label>
  <select
    id="travelMode"
    class="custom-select custom-select-sm"
    [(ngModel)]="currentStyle"
    [compareWith]="compareFnSelect"
    (change)="setStyle(currentStyle)">
    <option [attr.data-btnId]="getElementId('selectStyle_' + item.name)" *ngFor="let item of styles"
            [ngValue]="item">{{item.name | translate}}
    </option>
  </select>
</div>

<!-- Layer filters -->
<div class="layer-list">
  <label for="napit">{{'Filters:' | translate}}</label>
  <div class="blokki" *ngFor="let layer of notGroupedLayers$ | async">
    <div class="upper-part">
      <div class="layer-button-container">
        <button
          type="button"
          (click)="layer.toggleVisibility()"
          [ngClass]="{
            'btn layer-button btn-light button-top': true,
            'btn-layer-enabled': layer.style.visible && !(layer.metadata.visibleByZoom > currentZoomLevel),
            'btn-zoom-too-far': layer.style.visible && (layer.metadata.visibleByZoom > currentZoomLevel)
          }">
          <div class="layer-button-content">
            <div class="layer-button-text">
              {{layer.name | translate}}
            </div>
            <div>
              <div class="layer-button-spinner">
                <qm-layer-loading-status
                  [isLoaded$]="layer.isLoaded$">
                </qm-layer-loading-status>
              </div>
            </div>
          </div>
        </button>
        <button
          *ngIf="layer.style.visible && (layer.metadata.visibleByZoom > currentZoomLevel)"
          type="button"
          class="btn layer-zoom-btn"
          (click)="zoomTo($event, layer.metadata.visibleByZoom)">
            <i class="far fa-search-plus"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="blokki" id="napit" *ngFor="let layerGroup of layerGroupMap.values()">
    <div class="upper-part">
      <div class="layer-button-container">
        <div
          [ngClass]="{
            'layer-button button-top': true,
            'group-button': true,
            'group-button-enabled': (layerGroup.group.isVisible$ | async),
            'group-button-disabled': !(layerGroup.group.isVisible$ | async)
          }">
          <div class="group-button-content">
            <div>
              <label class="switch">
                <input
                  type="checkbox"
                  (click)="toggleGroupVisibility($event, layerGroup.group)"
                  [checked]="(layerGroup.group.isVisible$ | async)">
                <span class="slider round"></span>
              </label>
            </div>
            <div class="group-button-text">
              <div>
                {{layerGroup.group.name | translate}}
              </div>
              <div class="selected-layer-count">
                {{getVisibleLayerCount(layerGroup.group.name)}}
              </div>
            </div>
            <div>
              <div
                [ngClass]="{
                  'accordion-triangle': true,
                  'arrow-up': layerGroup.expanded,
                  'arrow-down': !layerGroup.expanded
                }"
                [style.color]="(layerGroup.group.isVisible$ | async) ? 'white' : 'black'"
                (click)="toggleLayerGroupExpanded(layerGroup)">
                  <i class="fas fa-play"></i>
              </div>
            </div>
            <div *ngIf="!allLayersLoaded(layerGroup.group.name)">
              <qm-layer-loading-status
                [isLoaded]="allLayersLoaded(layerGroup.group.name)">
              </qm-layer-loading-status>
            </div>
          </div>
        </div>
      </div>
      <div class="lower-part" *ngIf="layerGroup.expanded">
        <div class="filters">
          <div *ngFor="let layer of layerGroup.group.layers">
            <div class="layer-button-container">
              <button
                type="button"
                (click)="layer.toggleIsSelected()"
                [ngClass]="{
                  'btn layer-button btn-light group-layer-button': true,
                  'btn-layer-enabled': (layer.isSelected$ | async),
                  'btn-zoom-too-far': (layer.isVisible$ | async)
                                      && (layer.metadata.visibleByZoom > currentZoomLevel)
                }"
                [ngStyle]="{'padding-left': '0.5em'}"> <!-- Padding for compemsating the spinner -->
                <div class="layer-button-content">
                  <div class="layer-button-text">
                    {{layer.name | translate}}
                  </div>
                  <div>
                    <div class="layer-button-spinner">
                      <qm-layer-loading-status
                        [isLoaded$]="layer.isLoaded$">
                      </qm-layer-loading-status>
                    </div>
                  </div>
                </div>
              </button>
              <button
                *ngIf="(layer.isLoaded$ | async)
                        && (layer.isVisible$ | async)
                        && (layer.metadata.visibleByZoom > currentZoomLevel)"
                type="button"
                class="btn layer-zoom-btn group-layer-button"
                (click)="zoomTo($event, layer.metadata.visibleByZoom)">
                <i class="far fa-search-plus"></i>
              </button>
            </div>
          </div>
          <div class="layer-button-container">
            <button
                type="button"
                class="btn clear-button"
                (click)="clearLayerSelections(layerGroup.group)">
                {{'Clear' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Marker mode -->
<qm-marker-mode-settings *ngIf="hasMultipleMarkerModes"></qm-marker-mode-settings>